<template>
    <Fragment>
        <a class="button" v-show="isAuthenticated" @click="logout">Logg ut</a>
    </Fragment>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Fragment } from 'vue-fragment';

export default {
    components: { Fragment },
    computed: {
        ...mapState('session', ['isAuthenticated']),
    },
    methods: {
        ...mapActions('session', ['unloadProfile']),
        logout() {
            this.unloadProfile();
            this.$router.push({ name: 'Catches' });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
